import { Star, QrCode, ScanLine, LineChart, Building2, Cpu } from "lucide-react";

const PLAQUETTE_IMG =
  "https://customer-assets.emergentagent.com/job_google-chevalet/artifacts/is4v9l7e_1000202828.jpg";
const MENU_IMG =
  "https://images.unsplash.com/photo-1625038624658-01a222d8fb8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxxciUyMGNvZGUlMjByZXN0YXVyYW50JTIwbWVudSUyMGRhcmt8ZW58MHx8fHwxNzgxNjQ3ODI1fDA&ixlib=rb-4.1.0&q=85";
const GESTION_IMG =
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const BORNE_IMG =
  "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const PLAQUETTE_IMAGE = PLAQUETTE_IMG;

export const PRODUCTS = [
  {
    icon: Star,
    slug: "chevalet-avis-google",
    title: "Chevalet Avis Google",
    tag: "NFC + QR",
    desc: "Le chevalet connecté qui transforme vos clients satisfaits en avis 5 étoiles. Un tap suffit. Boostez votre fiche et dépassez vos concurrents.",
    span: "md:col-span-7",
    image: PLAQUETTE_IMG,
    detailImage: PLAQUETTE_IMG,
    longDesc:
      "Le chevalet avis Google est un support physique connecté, posé en caisse ou sur le comptoir. Au moment où votre client est le plus satisfait, il approche son smartphone (NFC) ou scanne le QR code : la page d'avis s'ouvre instantanément. Plus d'avis, plus de visibilité, plus de clients.",
    benefits: [
      "Jusqu'à 2x plus d'avis collectés en quelques semaines",
      "Aucune application à installer pour le client",
      "NFC + QR code : compatible avec tous les smartphones",
      "Personnalisé à votre charte graphique",
    ],
    how: [
      { t: "Le client termine son achat", d: "Au moment où il est le plus satisfait de votre service." },
      { t: "Il approche son téléphone ou scanne", d: "NFC sans contact ou QR code, en une seconde." },
      { t: "Il laisse un avis 5 étoiles", d: "Votre fiche Google grimpe dans le classement local." },
    ],
  },
  {
    icon: QrCode,
    slug: "menu-digital-qr",
    title: "Menu Digital QR",
    tag: "Restauration",
    desc: "Le menu digital sans contact pour les restaurateurs. Mise à jour en temps réel, zéro papier.",
    span: "md:col-span-5",
    image: MENU_IMG,
    detailImage: MENU_IMG,
    longDesc:
      "Remplacez vos cartes papier par un menu digital élégant, accessible en scannant un QR code sur la table. Changement de prix, plat du jour, rupture de stock : tout se met à jour instantanément, sans réimpression. Une image moderne et des coûts réduits.",
    benefits: [
      "Mise à jour en temps réel, zéro réimpression",
      "Photos, allergènes et suggestions intégrés",
      "Expérience sans contact appréciée des clients",
      "Bouton avis Google en fin de repas",
    ],
    how: [
      { t: "Le client s'installe", d: "Il scanne le QR code posé sur la table." },
      { t: "Il consulte votre carte", d: "Photos, prix à jour, allergènes, suggestions." },
      { t: "Il laisse un avis", d: "Un bouton l'invite à noter son expérience." },
    ],
  },
  {
    icon: ScanLine,
    slug: "bornes-plaquettes",
    title: "Bornes & Plaquettes",
    tag: "Sur mesure",
    desc: "Supports physiques connectés conçus en interne pour vos points de vente et événements.",
    span: "md:col-span-5",
    image: BORNE_IMG,
    detailImage: BORNE_IMG,
    longDesc:
      "Nous concevons en interne des supports connectés sur mesure : plaquettes, bornes, totems, cartes NFC. Idéal pour les réseaux de points de vente, les événements et les déploiements nationaux. Du design à la production, tout est piloté par nos équipes.",
    benefits: [
      "Conception et production internes",
      "Déploiement multi-sites à l'échelle nationale",
      "Matériaux et formats sur mesure",
      "Logistique et suivi centralisés",
    ],
    how: [
      { t: "Cadrage du besoin", d: "On définit ensemble formats, technologies et volumes." },
      { t: "Design & production", d: "Nos équipes conçoivent et fabriquent vos supports." },
      { t: "Déploiement & suivi", d: "Livraison sur tous vos sites, avec accompagnement." },
    ],
  },
  {
    icon: LineChart,
    slug: "gestion-fiche-google",
    title: "Gestion de Fiche Google",
    tag: "SaaS humain",
    desc: "Pilotage de votre présence locale : réponse aux avis, posts, photos, reporting mensuel — opéré par nos experts.",
    span: "md:col-span-7",
    image: GESTION_IMG,
    detailImage: GESTION_IMG,
    longDesc:
      "On pilote votre fiche Google Business comme un vrai canal d'acquisition : optimisation, réponse aux avis, publications, photos et reporting mensuel. Le tout en mode SaaS, mais avec un interlocuteur humain dédié qui connaît votre enseigne.",
    benefits: [
      "Réponse aux avis et modération",
      "Publications et photos régulières",
      "Suivi de positionnement local",
      "Reporting mensuel + interlocuteur dédié",
    ],
    how: [
      { t: "Audit de votre présence", d: "On analyse votre fiche et vos concurrents." },
      { t: "Pilotage mensuel", d: "Avis, posts, photos, optimisations en continu." },
      { t: "Reporting & ajustements", d: "Un bilan clair chaque mois, opéré par un humain." },
    ],
  },
];

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const CLIENTS = ["Caisse d'Épargne", "Groupama", "Renault", "Nissan"];

export const PRICING = [
  {
    name: "Suivi",
    price: "39",
    period: "/ mois",
    tagline: "Le dashboard des avis Google pour démarrer",
    cap: "Jusqu'à 100 QR codes",
    features: [
      "Tableau de bord de vos avis Google",
      "Jusqu'à 100 QR codes dynamiques",
      "Suivi des scans en temps réel",
      "Note & avis centralisés",
      "Support par email",
    ],
    highlighted: false,
    sujet: "Dashboard Suivi (39€/mois)",
  },
  {
    name: "Business",
    price: "125",
    period: "/ mois",
    tagline: "Pour les réseaux multi-points de vente",
    cap: "Jusqu'à 1 000 QR codes",
    features: [
      "Tout du plan Suivi",
      "Jusqu'à 1 000 QR codes dynamiques",
      "Classement de vos points de vente",
      "Synthèse de vos avis par thème",
      "Interlocuteur dédié",
    ],
    highlighted: true,
    sujet: "Dashboard Business (125€/mois)",
  },
  {
    name: "Sur Mesure",
    price: "Sur devis",
    period: "",
    tagline: "Au-delà de 1 000 QR & grands comptes",
    cap: "QR codes illimités",
    features: [
      "QR codes illimités",
      "Déploiement national multi-marques",
      "Tableau de bord centralisé",
      "Account manager dédié",
      "SLA & engagement contractuel",
    ],
    highlighted: false,
    sujet: "Dashboard sur mesure (1000+ QR)",
  },
];


export const STEPS = [
  {
    icon: Building2,
    title: "Audit & stratégie",
    desc: "On analyse votre présence locale et on définit un plan sur mesure adapté à votre enseigne.",
  },
  {
    icon: Cpu,
    title: "Technologie interne",
    desc: "On conçoit et déploie nos supports connectés et nos outils développés en interne.",
  },
  {
    icon: LineChart,
    title: "Suivi humain",
    desc: "Un interlocuteur dédié pilote, optimise et vous rend des comptes chaque mois.",
  },
];
